import type {DynamicNodeDefinition} from './types';

const byKindId = new Map<string, DynamicNodeDefinition>();

export function registerDynamicNode(def: DynamicNodeDefinition): void {
  byKindId.set(def.kindId, def);
}

export function getDynamicNodeDef(kindId: string): DynamicNodeDefinition | undefined {
  return byKindId.get(kindId);
}

/** All registered kinds, stable order: category key (uncategorized last), then `kindId`. */
export function listRegisteredDynamicNodeDefs(): DynamicNodeDefinition[] {
  const defs = Array.from(byKindId.values());
  const categoryRank = (key: string | undefined) => (key ? key : '\uFFFF');
  defs.sort((a, b) => {
    const ca = categoryRank(a.categoryKey);
    const cb = categoryRank(b.categoryKey);
    if (ca !== cb) {
      return ca.localeCompare(cb);
    }
    return a.kindId.localeCompare(b.kindId);
  });
  return defs;
}
